module.exports = __webpack_public_path__ + "img/CropOriginalOutlined.151c9e6b.svg";